/**
 * Returns a ref that's `false` during SSR and on the first client render,
 * flipped to `true` in onMounted (after hydration completes).
 *
 * Uses a module-level flag so that once the app has hydrated, any component
 * created after that point (e.g. slot children revealed by a parent container)
 * gets `true` immediately — preventing the "card outline with skeletons inside"
 * intermediate state that occurs when a parent reveals its slot after mount.
 */

let appMounted = false;

export function useIsMounted() {
  if (appMounted) {
    return ref(true);
  }

  const mounted = ref(false);
  onMounted(() => {
    mounted.value = true;
    appMounted = true;
  });
  return mounted;
}
